var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaverse4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 2.26111C12.3672 1.91296 11.6328 1.91296 11.0287 2.26111L4.02872 6.29559C3.94578 6.3434 3.86696 6.3968 3.79259 6.45521L7.80506 8.76782C7.76889 8.55151 7.75001 8.32854 7.75001 8.1C7.75001 5.75747 9.73318 4 12 4C14.2668 4 16.25 5.75747 16.25 8.1C16.25 8.32854 16.2311 8.55151 16.195 8.76782L20.2074 6.45521C20.1331 6.3968 20.0542 6.3434 19.9713 6.29559L12.9713 2.26111Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72821 10.5037L3.02347 7.79211C3.00797 7.89614 3 8.00215 3 8.10935V16.042C3 16.7955 3.39378 17.4898 4.02871 17.8558L11.0287 21.8903C11.1008 21.9318 11.1747 21.9684 11.25 22V19.9615C7.7994 19.606 5 16.8261 5 13.3C5 11.7283 6.27994 10.577 7.72821 10.5037Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.3C19 16.8261 16.2006 19.606 12.75 19.9615V22C12.8253 21.9684 12.8992 21.9318 12.9713 21.8903L19.9713 17.8558C20.6062 17.4898 21 16.7955 21 16.042V8.10935C21 8.00215 20.992 7.89614 20.9765 7.79211L16.2718 10.5037C17.7201 10.577 19 11.7283 19 13.3Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.7C13.5188 10.7 14.75 9.53594 14.75 8.1C14.75 6.66406 13.5188 5.5 12 5.5C10.4812 5.5 9.25 6.66406 9.25 8.1C9.25 9.53594 10.4812 10.7 12 10.7Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 12C7.11561 12 6.5 12.582 6.5 13.3C6.5 16.1719 8.96243 18.5 12 18.5C15.0376 18.5 17.5 16.1719 17.5 13.3C17.5 12.582 16.8844 12 16.125 12H7.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse4);
export default __webpack_public_path__ + "static/media/metaverse-4.8349202f1930feb8b6b0eee69187b2bd.svg";
export { ForwardRef as ReactComponent };